import gql from 'graphql-tag';

const ALL_DEVICE_QUERY = gql`
  query Query($searchQuery: String!) {
    alldevices(searchQuery: $searchQuery) {
      sensors
      deviceSerialNo
    }
  }
`;

export default ALL_DEVICE_QUERY;
